import { Component, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Confirmation modal shown when the user navigates away from an HTML wiki
 * page that was auto-converted to Markdown for editing and has unsaved
 * changes.
 *
 * The user picks one of three outcomes:
 *   - 'save'    → save the edited content as Markdown (permanently converting
 *                 the stored page format).
 *   - 'discard' → leave without saving. The page remains stored as HTML.
 *   - 'cancel'  → stay on the edit view (dismissed via activeModal.dismiss).
 */
@Component({
    selector: 'wiki-convert-on-save-modal',
    template: require('./wiki.convert-on-save-modal.component.html')
})
export class WikiConvertOnSaveModalComponent {
    @Output() save = new EventEmitter<void>();
    @Output() discard = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    constructor(public activeModal: NgbActiveModal) {}

    onSave(): void {
        this.save.emit();
        this.activeModal.close('save');
    }

    onDiscard(): void {
        this.discard.emit();
        this.activeModal.close('discard');
    }

    onCancel(): void {
        this.cancel.emit();
        this.activeModal.dismiss('cancel');
    }
}
